import { 
  Component, 
  OnInit,
  OnChanges,
  Input,
  SimpleChanges, 
  EventEmitter,
  Output,
  Inject
} from '@angular/core';

import { FatNumberStyles } from './models/widget';
import { isNil } from 'lodash-es';
import { BaseComponent } from './components/base.component';

import { SharedModule } from './shared.module';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';
import { SalesOrders_ShellService } from './SalesOrders.shell.service';
import { SalesOrders_OperationService } from './SalesOrders.operation.service';
import { SalesOrders_DatasourceService } from './SalesOrders.datasource.index';
import { SalesOrders_FlowService } from './SalesOrders.flow.index';
import { SalesOrders_ReportService } from './SalesOrders.report.index';
import { SalesOrders_LocalizationService } from './SalesOrders.localization.service';
import { SalesOrders_order_total_picked_units_by_date_widget_ComponentContextService } from './SalesOrders.order_total_picked_units_by_date_widget.component.context.service';
import { Language } from './localization.service';
import { JobStatus } from './common-interfaces'
import { ApplicationType, ComponentType } from './app-context.service';
import { CleanupLoggerService } from './cleanup.logging.service';
import { $frontendTypes} from './SalesOrders.frontend.types'
import { $frontendTypes as $types} from './SalesOrders.frontend.types' 

import { EModalSize, EToasterType, EToasterPosition } from 'wavelength-ui';

@Component({
  standalone: true,
  imports: [
    SharedModule,
  ],
  selector: 'SalesOrders-order_total_picked_units_by_date_widget',
  templateUrl: './SalesOrders.order_total_picked_units_by_date_widget.component.html'
})
export class SalesOrders_order_total_picked_units_by_date_widgetComponent extends BaseComponent implements OnInit, OnChanges {
  //#region Outputs
  @Output()
  $refreshEvent = new EventEmitter();
  //#endregion Outputs

  inParams: { date: string, ownerId?: number, projectId?: number, warehouseId?: number[], orderStatusIds?: number[] } = { date: null, ownerId: null, projectId: null, warehouseId: [], orderStatusIds: [] };
  //#region Inputs
  @Input('date') set $inParams_date(v: string) {
    this.inParams.date = v;
  }
  get $inParams_date(): string {
    return this.inParams.date;
  }
  @Input('ownerId') set $inParams_ownerId(v: number) {
    this.inParams.ownerId = v;
  }
  get $inParams_ownerId(): number {
    return this.inParams.ownerId;
  }
  @Input('projectId') set $inParams_projectId(v: number) {
    this.inParams.projectId = v;
  }
  get $inParams_projectId(): number {
    return this.inParams.projectId;
  }
  @Input('warehouseId') set $inParams_warehouseId(v: number[]) {
    this.inParams.warehouseId = v;
  }
  get $inParams_warehouseId(): number[] {
    return this.inParams.warehouseId;
  }
  @Input('orderStatusIds') set $inParams_orderStatusIds(v: number[]) {
    this.inParams.orderStatusIds = v;
  }
  get $inParams_orderStatusIds(): number[] {
    return this.inParams.orderStatusIds;
  }
  //#endregion Inputs

  //#region Variables
  //#endregion  
  private entity: { TotalUnits?: number };

  value: any;
  styles: FatNumberStyles;
  originalValue: any;
  prefix: string = '';
  suffix: string = '';

  constructor(private $utils: UtilsService,
private $settings: SettingsValuesService,
private $shell: SalesOrders_ShellService,
private $datasources: SalesOrders_DatasourceService,
private $flows: SalesOrders_FlowService,
private $reports: SalesOrders_ReportService,
private $localization: SalesOrders_LocalizationService,
private $operations: SalesOrders_OperationService,
private $logger: CleanupLoggerService,
private $context: SalesOrders_order_total_picked_units_by_date_widget_ComponentContextService,
) { 
    super();

    this.styles = new FatNumberStyles();
  }

  ngOnInit(): void {
    this.$checkRequiredInParams();
    if (!this.$hasMissingRequiredInParams) {
      this.$init();
    } else {
      this.$initEmpty();
    }
  }
  
  private $isFirstNgOnChanges = true;
  ngOnChanges(changes: SimpleChanges): void {
    if (this.$isFirstNgOnChanges) {
      this.$isFirstNgOnChanges = false;
    } else {
      this.$checkRequiredInParams();
      if(!this.$hasMissingRequiredInParams) {
        this.$init();
      } else {
        this.$initEmpty();
      }
    }
  }

  $missingRequiredInParams = [];
  get $hasMissingRequiredInParams(): boolean {
    return !!this.$missingRequiredInParams.length;
  }
  
  $checkRequiredInParams() {
    this.$missingRequiredInParams = [];
      if(isNil(this.inParams.date)) {
        this.$missingRequiredInParams.push('date');
      }
  }

  initialized = false;
  $hasDataLoaded = false;

  async $init() {

    await this.$dataLoad();

    this.initialized = true;
  }
  
  async $dataLoad() {
    const $widget = this;
    const $utils = this.$utils;

    const dsParams = {
      date:  $widget.inParams.date ,
      ownerId:  $widget.inParams.ownerId ,
      projectId:  $widget.inParams.projectId ,
      warehouseId:  $widget.inParams.warehouseId ,
      orderStatusIds:  $widget.inParams.orderStatusIds 
    };

    const data = await this.$datasources.SalesOrders.ds_order_total_picked_units_by_date_widget.get(dsParams);
    if (isNil(data.result)) {
      this.$hasDataLoaded = false;
      this.entity = null;
    } else {
      this.$hasDataLoaded = true;
      this.entity = data.result;
      await this.$dataLoaded();
    }
  }

  async $dataLoaded() {
    const $widget = this;
    const $utils = this.$utils;

    this.value = this.format($utils.isDefined($widget.entity.TotalUnits) ? $widget.entity.TotalUnits : 0, 1);

    await this.on_data_loaded();
    
    this.originalValue = $utils.isDefined($widget.entity.TotalUnits) ? $widget.entity.TotalUnits : 0;
  }

  format(num: number, digits: number): string {
    // at some point in time we should probably respect the selected culture from the localization service
    return isNil(num)
      ? ''
      : Intl.NumberFormat('en-US', { notation: "compact", maximumFractionDigits: digits}).format(num);
  }

  refresh(
    skipParent = false,
    skipChildren = false,
    childToSkip: string = null) {
    if (this.$hasMissingRequiredInParams) {
      return Promise.resolve(null);
    }
    // up
    if (skipParent === false) {
      this.$refreshEvent.emit();
    }

    // self
    const result = this.$dataLoad();

    // children
    if (skipChildren === false) {
    }

    return result;
  }

  getStyleClass() {
    const valString = isNil(this.value) ? '' : this.value.toString();
    const length = (valString).length;
    if (length === 2) {
      return 'tens';
    }
    if (length === 3) {
      return 'hundreds';
    }
    if (length === 4) {
      return 'thousands';
    }
    if (length === 5) {
      return 'tenThousands';
    }
    if (length === 6) {
      return 'hundredThousands';
    }
    if (length > 6) {
      return 'millions';
    }
    return null;
  }

  //#region private flows
  on_data_loaded(event = null) {
    return this.on_data_loadedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_data_loadedInternal(
    $widget: SalesOrders_order_total_picked_units_by_date_widgetComponent,
  
    $shell: SalesOrders_ShellService,
    $datasources: SalesOrders_DatasourceService,
    $flows: SalesOrders_FlowService,
    $reports: SalesOrders_ReportService,
    $settings: SettingsValuesService,
    $operations: SalesOrders_OperationService,
    $utils: UtilsService,
    $context: SalesOrders_order_total_picked_units_by_date_widget_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: SalesOrders_LocalizationService,
    $event: any
  ) {
  if ($utils.isDefined($widget.entity.TotalUnits)) {
      if ($widget.entity.TotalUnits == 0) {
          $widget.styles.clearStyle();
          $widget.styles.setBadClass();
      }
      else if ($widget.entity.TotalUnits > 0 && $widget.entity.TotalUnits <= 1000) {
          $widget.styles.clearStyle();
          $widget.styles.setMediumClass();
      }
      else {
          $widget.styles.clearStyle();
          $widget.styles.setGoodClass();
  
      }
  }
  }
  //#endregion private flows
}
